// web/apps/shared/src/constants

/**
 * Global Application Constants & Environment Settings
 * (Injected via CI/CD or .env)
 */
export const APP_VERSION = process.env.REACT_APP_PWA_VERSION || "1.0.0-dev";
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || "seims.helpdesk@saasta.nrf.ac.za";
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";


/** Events storage Configuration
 *  Ensure this matches the name used in your IndexedDB initialization
*/
export const EVENTS_DB_NAME = "my-pwa-db";

/** Core system stores */
export const LOOKUP_META_STORE = "lookupMeta";
export const USER_RECORDS_STORE = "userRecords";
export const CLEANUP_LOGS_STORE = "cleanupLogs";
export const OFFLINE_DATA_STORE = "offlineData";

/** Lookup stores */
export const EVENT_STATUS_STORE_NAME = "eventStatus";
export const EVENT_TYPES_STORE_NAME = "eventTypes";
export const EVENT_GROUPS_STORE_NAME = "eventGroups";
export const VENUE_TYPES_STORE_NAME = "venueTypes";
export const TARGET_PARTICIPANTS_STORE_NAME = "targetParticipants";
export const EVENT_OBJECTIVES_STORE_NAME = "eventObjectives";
export const ORGANISER_EXPERIENCE_STORE_NAME = "organiserExperience";
export const PARTICIPANT_DISABILITIES_STORE_NAME = "participantDisabilities";
export const PARTICIPANT_TYPES_STORE_NAME = "participantTypes"
export const GENDERS_STORE_NAME = "genders";
export const RACES_STORE_NAME = "races";
export const AGE_GROUPS_STORE_NAME = "ageGroups";
export const LANGUAGES_STORE_NAME = "languages";
export const GEO_STORE_NAME = "provincesDistrictTowns";
export const PARTICIPANT_OCCUPATIONS_STORE_NAME = "participantOccupations";
export const EMPLOYMENT_SECTORS_STORE_NAME = "employmentSectors";
export const EVENT_ROLES_STORE_NAME = "eventRoles";
export const ATTENDEE_MOTIVATIONS_STORE_NAME = "attendeeMotivations";
export const QUALIFICATIONS_STORE_NAME = "postMetricQualifications";
export const PROVINCES_DISTRICTS_TOWNS_STORE_NAME = "provincesDistrictsTowns";
export const PROVINCES_DISTRICTS_STORE_NAME = "provincesDistrictsTowns";

/** Cached data stores */
export const FAQS_STORE_NAME = "faqs";
export const EVENTS_LISTING_STORE_NAME = "events-listing";

/** Events-app store registry */
export const REQUIRED_EVENTSAPP_STORES = [
  LOOKUP_META_STORE,
  USER_RECORDS_STORE,
  CLEANUP_LOGS_STORE,
  OFFLINE_DATA_STORE,

  EVENT_STATUS_STORE_NAME,
  EVENT_TYPES_STORE_NAME,
  EVENT_GROUPS_STORE_NAME,
  VENUE_TYPES_STORE_NAME,
  TARGET_PARTICIPANTS_STORE_NAME,
  EVENT_OBJECTIVES_STORE_NAME,
  ORGANISER_EXPERIENCE_STORE_NAME,
  PARTICIPANT_DISABILITIES_STORE_NAME,
  GENDERS_STORE_NAME,
  RACES_STORE_NAME,
  AGE_GROUPS_STORE_NAME,
  LANGUAGES_STORE_NAME,
  PARTICIPANT_OCCUPATIONS_STORE_NAME,
  PARTICIPANT_TYPES_STORE_NAME,
  EMPLOYMENT_SECTORS_STORE_NAME,
  EVENT_ROLES_STORE_NAME,
  ATTENDEE_MOTIVATIONS_STORE_NAME,
  QUALIFICATIONS_STORE_NAME,
  PROVINCES_DISTRICTS_STORE_NAME,

  // 
  GEO_STORE_NAME,
  FAQS_STORE_NAME,
  EVENTS_LISTING_STORE_NAME,
];

export const APPLICATION_NAMES = Object.freeze({
  "EVENTS_APP": "events",
  "BACK_OFFICE": "seimscore",
  "PUBLIC_PORTAL": "pubweb",
})
